/* Paul & Romi · Q4-Reframe: Anker-Scroll, Sticky-Leiste, Serien-Chips. Ohne Bibliotheken. */
(function () {
  'use strict';
  if (window.__prQ4Init) return;
  window.__prQ4Init = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerOffset() {
    /* Runde 6: Im Theme ist die Section-Hülle der Kopfzeile sticky (shopify-section-group-header-group), nicht .header selbst. */
    var list = document.querySelectorAll('.shopify-section-group-header-group, .header, #header, header[role="banner"]');
    for (var i = 0; i < list.length; i++) {
      var pos = getComputedStyle(list[i]).position;
      if (pos === 'sticky' || pos === 'fixed') return list[i].getBoundingClientRect().height + 8;
    }
    return 0;
  }

  /* Anker in den Q4-Sections: ruhig scrollen, Kopfzeile berücksichtigen */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.prq a[href^="#"], .prq-sticky a[href^="#"]');
    if (!a || a.hasAttribute('data-prq-serie')) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* Sticky-Leiste: sichtbar, sobald der Hero aus dem Bild ist; weg, wenn das Ziel sichtbar ist */
  function initSticky(bar) {
    var heroId = bar.getAttribute('data-hero');
    var hero = heroId ? document.getElementById(heroId) : null;
    var targetHref = bar.querySelector('a[href^="#"]');
    var target = targetHref ? document.getElementById(targetHref.getAttribute('href').slice(1)) : null;
    if (!hero || !('IntersectionObserver' in window)) return;
    var heroOut = false, targetIn = false, footerIn = false;
    var footer = document.querySelector('footer');
    function update() { bar.classList.toggle('is-visible', heroOut && !targetIn && !footerIn); }
    new IntersectionObserver(function (es) { es.forEach(function (x) { heroOut = !x.isIntersecting && x.boundingClientRect.bottom < 0; }); update(); }, { threshold: 0 }).observe(hero);
    if (target) new IntersectionObserver(function (es) { es.forEach(function (x) { targetIn = x.isIntersecting; }); update(); }, { threshold: 0.05 }).observe(target);
    if (footer) new IntersectionObserver(function (es) { es.forEach(function (x) { footerIn = x.isIntersecting; }); update(); }, { threshold: 0 }).observe(footer);
  }

  /* Serien-Chips der Paketübersicht: aktive Serie markieren */
  function initChips(section) {
    var chips = section.querySelectorAll('[data-prq-chip]');
    if (!chips.length || !('IntersectionObserver' in window)) return;
    var map = {};
    chips.forEach(function (c) { map[c.getAttribute('href').slice(1)] = c; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        chips.forEach(function (c) { c.removeAttribute('aria-current'); });
        var chip = map[x.target.id];
        if (chip) {
          chip.setAttribute('aria-current', 'true');
          if (chip.scrollIntoView && !reduce) chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
    section.querySelectorAll('.prq-group[id]').forEach(function (g) { io.observe(g); });
  }

  /* Runde 5: Video-Schleifen (Hero, Last Pieces). Das Bild darunter ist Poster und LCP.
     Quelle erst nach window.load und nur im Bild; mobil Hochformat, Desktop nur mit Querfassung; reduzierte Bewegung: nur Bild.
     Knopf „Pause“ (WCAG 2.2.2), Nutzerpause bleibt bestehen. */
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var pageLoaded = document.readyState === 'complete';
  var videoQueue = [];
  window.addEventListener('load', function () { pageLoaded = true; videoQueue.splice(0).forEach(function (f) { f(); }); });
  function initVideo(v) {
    if (v.__prq) return; v.__prq = true;
    var host = v.closest('.prq-hero, [data-prq-media]') || v.parentElement;
    var btn = host ? host.querySelector('[data-prq-video-toggle]') : null;
    var visible = false, userPaused = false;
    function src() { return (mqMobile && mqMobile.matches ? v.getAttribute('data-src-m') : v.getAttribute('data-src-d')) || ''; }
    function stop() { if (!v.paused) v.pause(); }
    function sync() {
      var s = src();
      if (!s || (mqReduce && mqReduce.matches)) { stop(); v.classList.remove('is-playing'); v.hidden = true; if (btn) btn.hidden = true; return; }
      v.hidden = false; if (btn) btn.hidden = false;
      if (!visible || userPaused) { stop(); return; }
      if (!pageLoaded) { videoQueue.push(sync); return; }
      if (v.getAttribute('src') !== s) { v.setAttribute('src', s); }
      v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    if (btn) btn.addEventListener('click', function () {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', String(userPaused)); btn.textContent = userPaused ? 'Abspielen' : 'Pause';
      sync();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (x) { visible = x.isIntersecting; }); sync(); }, { rootMargin: '200px 0px' }).observe(host || v);
    } else { visible = true; sync(); }
    [mqMobile, mqReduce].forEach(function (mq) { if (mq && mq.addEventListener) mq.addEventListener('change', sync); });
    sync();
  }

  /* Runde 6 (Owner 07.10., Punkt 2): Bühne der Angebotsseite. Serien-Pille wechselt das Bild der Bühne und zeigt nur die Kacheln
     dieser Serie. Bilder der anderen Serien liegen als <template> vor und werden erst bei Bedarf (Pille berührt oder gewählt) geladen.
     Ohne JavaScript: alle Serien sichtbar, Pillen sind Anker. Tiefer Link #paket-<serie> wählt die Serie. */
  function initStage(section) {
    if (section.__prqStage) return; section.__prqStage = true;
    var stage = section.querySelector('[data-prq-stage]');
    var pills = [].slice.call(section.querySelectorAll('[data-prq-serie]'));
    var groups = [].slice.call(section.querySelectorAll('[data-prq-group]'));
    if (!stage || !pills.length || !groups.length) return;
    var media = stage.querySelector('.prq-stage__media');
    function pic(key) {
      var el = media.querySelector('[data-prq-stage-pic="' + key + '"]');
      if (el) return el;
      var tpl = media.querySelector('template[data-prq-stage-tpl="' + key + '"]');
      if (!tpl) return null;
      media.appendChild(tpl.content.cloneNode(true));
      tpl.parentNode.removeChild(tpl);
      return media.querySelector('[data-prq-stage-pic="' + key + '"]');
    }
    function show(el) {
      [].forEach.call(media.querySelectorAll('[data-prq-stage-pic]'), function (p) { p.classList.toggle('is-active', p === el); });
    }
    function activate(key, opts) {
      opts = opts || {};
      var known = groups.some(function (g) { return g.getAttribute('data-prq-group') === key; });
      if (!known) return false;
      pills.forEach(function (p) { if (p.getAttribute('data-prq-serie') === key) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current'); });
      groups.forEach(function (g) { g.hidden = g.getAttribute('data-prq-group') !== key; });
      var el = pic(key);
      if (el) {
        var img = el.querySelector('img');
        if (img) img.loading = 'eager';
        if (!img || img.complete) show(el);
        else { img.addEventListener('load', function () { show(el); }, { once: true }); img.addEventListener('error', function () { show(el); }, { once: true }); }
      }
      if (opts.hash && history.replaceState) history.replaceState(null, '', '#paket-' + key);
      return true;
    }
    section.classList.add('is-tabs');
    pills.forEach(function (p) {
      var key = p.getAttribute('data-prq-serie');
      p.addEventListener('click', function (e) { e.preventDefault(); activate(key, { hash: true }); });
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { p.addEventListener(ev, function () { var el = pic(key); var img = el && el.querySelector('img'); if (img) img.loading = 'eager'; }, { passive: true, once: true }); });
    });
    var start = (location.hash || '').replace(/^#paket-/, '');
    if (start && start !== location.hash && activate(start)) {
      /* Tiefer Link: Bühne mit Pillen zeigen (der Browser springt sonst nach dem Laden auf die Kachelgruppe unter der Bühne). */
      var goStage = function () { var top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset(); window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' }); };
      goStage();
      if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(goStage, 60); }, { once: true });
    } else {
      activate(pills[0].getAttribute('data-prq-serie'));
    }
  }

  function init() {
    document.querySelectorAll('.prq-sticky[data-hero]').forEach(initSticky);
    document.querySelectorAll('.prq-pakete').forEach(initChips);
    document.querySelectorAll('.prq-pakete[data-prq-buehne]').forEach(initStage);
    document.querySelectorAll('video[data-prq-video]').forEach(initVideo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
